import md5 from "blueimp-md5";
import request from "@/utils/request";
/**
 * 用户手机登录接口
 */
export function login(data: any) {
  return request({
    url: "v1/user/auth/login",
    method: "post",
    data
  });
}

//banner列表
export function bannerList(params: any) {
  return request({
    url: "api/client/banner/all",
    method: "get",
    params: params
  });
}
//学员列表
export function studentList(params: any) {
  return request({
    url: "api/client/student/list",
    method: "get",
    params: params
  });
}

//活动列表
export function activityList(params: any) {
  return request({
    url: "api/client/activity/list",
    method: "get",
    params: params
  });
}

//活动详情
export function activityInfo(params: any) {
  return request({
    url: "api/client/activity/info",
    method: "get",
    params: params
  });
}
//项目详情
export function projectInfo(params: any) {
  return request({
    url: "api/client/project/info",
    method: "get",
    params: params
  });
}
//讲师列表
export function teacherList(params: any) {
  return request({
    url: "api/client/teacher/list",
    method: "get",
    params: params
  });
}
//讲师详情
export function teacherInfo(params: any) {
  return request({
    url: "/api/client/teacher/info",
    method: "get",
    params: params
  });
}
// 问题列表
export function questionList(params: any) {
  return request({
    url: "api/client/qanda/list",
    method: "get",
    params: params
  });
}
// 课程预告
export function courseList(params: any) {
  return request({
    url: "api/client/course/open/notice",
    method: "get",
    params: params
  });
}
// 光华商学展示
export function collegeList(params: any) {
  return request({
    url: "api/client/course/college/view",
    method: "get",
    params: params
  });
}

// 咨询数记录
export function setCount(data: any) {
  return request({
    url: "api/client/util/consult_num",
    method: "post",
    params: data
  });
}

// 课程详情
export function openInfo(params: any) {
  return request({
    url: "/api/client/course/open/info",
    method: "get",
    params: params
  });
}
